module.exports = __webpack_public_path__ + "img/thumbnail_Meerkat_j_normal.e50c43f1.png";